import { Entity } from '../base/entity';

export class ItemOperation extends Entity {
    public static readonly TABLENAME = 'item_operations';

    public static readonly ITEM_ID = "item_id";
    public static readonly OPERATION_ID = "operation_id";
    public static readonly QUANTITY = "quantity";
    public static readonly SORT = "sort";


    itemId: String;
    operationId: number;
    quantity: String;
    sort?: number;
    

}